export const ACTIVITY_BADGE_CLASSNAME = 'rounded-full px-2.5 py-1 text-xs font-bold';

export const OUTLINE_MISSION_BUTTON_CLASSNAME =
  'inline-flex shrink-0 items-center justify-center gap-2 rounded-full border-2 border-[var(--color-mission)] bg-white px-5 py-2.5 text-sm font-extrabold text-[var(--color-mission)] transition-transform duration-100 active:scale-[0.97] hover:bg-[var(--color-mission)] hover:text-white';

// `activity-status-or-submitted-count` é um texto de status fixo pra aluno
// (ex.: "Atividade enviada"), mas pra professor/admin virou a contagem de
// respostas pendentes (número) — "0" é "sem pendência" e não deve virar
// badge no card (complementary-activity-card.jsx).
export function hasVisibleActivityStatus(value) {
  if (value === null || value === undefined || value === '') return false;
  const numericValue = Number(value);
  if (!Number.isNaN(numericValue)) return numericValue > 0;
  return true;
}

// Texto do badge: quando o valor é a contagem (professor/admin), vira "X para
// avaliar" — mesma mensagem usada no tema playful do professor
// (PlayfulTeacher/index.jsx, pendingEvaluationLabel). Quando é o status fixo
// do aluno, mostra como veio da API.
export function activityStatusLabel(value) {
  const numericValue = Number(value);
  if (value !== null && value !== undefined && value !== '' && !Number.isNaN(numericValue)) return `${numericValue} para avaliar`;
  return value;
}

// Critério do filtro "Pendente de avaliação" (Default/index.jsx): pra
// professor/admin é a contagem > 0; pra aluno é o status fixo "Atividade
// enviada" (aguardando avaliação do professor).
export function isPendingEvaluationStatus(value, t) {
  const numericValue = Number(value);
  if (value !== null && value !== undefined && value !== '' && !Number.isNaN(numericValue)) return numericValue > 0;
  return value === t('activity.activity_submitted');
}

export function activityStatusVariant(status, t) {
  if (status === t('activity.activity_not_submitted')) return 'danger-soft';
  if (status === t('activity.activity_submitted')) return 'success-soft';
  if (status === t('activity.activity_evaluated')) return 'success-soft';
  if (status === t('activity.awaiting_submission')) return 'amber-soft';
  return 'amber-soft';
}

// Status do activity_student na tela de avaliação (ex.: "Avaliação realizada"),
// vocabulário diferente do status usado na listagem/detalhe da atividade.
export function activityStudentStatusVariant(status, t) {
  if (status === t('activity.evaluationCompleted')) return 'success-soft';
  return 'amber-soft';
}

// Mesmo critério usado em activityStudentCard.jsx (tema Default): o envio do
// aluno já tem um comentário dele mesmo (a resposta); se existir algum
// comentário que não foi feito por "Aluno", é porque o professor já deu o
// parecer. Compartilhado entre a lista de alunos e a tela de avaliação do
// professor playful (ActivityEvaluationListTeacher / ActivityEvaluationDetailTeacher)
// pra não divergir.
export function isActivityStudentEvaluated(activityStudent) {
  return (activityStudent?.comments || []).some(comment => !comment.user?.includes('Aluno'));
}
